import {Base64} from 'js-base64';
import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues, ref } from '@dbk-legacy/muster/utils';
import isValidJsonString from '../../../utils/is-valid-json-string';
import { PAYMENTS_PATH, PAYMENT_BENF_ERROR_CODE, PAYMENT_PATH, INTERNATIONAL_PAYMENT } from './constant';
import Guid from '../../../utils/guid';
import { ROUTES, CoP, SEPA_PAYMENT_TYPE, IS_BANK_SEPA_PARTICIPANT } from '../../../constants';

const getStructuredAddressEnabled = async (get) => {
  const [enableStructuredAddress] = await getValues(get('app.config.enableStructuredAddress'));
  return Boolean(enableStructuredAddress);
};

const resolveCountryIsoCode = (countryValue, countryList = []) => {
  if (!countryValue) {
    return '';
  }

  const normalizedCountryValue = String(countryValue).trim();
  if (!normalizedCountryValue) {
    return '';
  }

  const safeCountryList = Array.isArray(countryList) ? countryList : [];
  const matchedCountry = safeCountryList.find((item) => {
    const countryName = (item?.countryName || '').toLowerCase();
    const isoCode = (item?.isocode || '').toLowerCase();
    const searchValue = normalizedCountryValue.toLowerCase();

    return countryName === searchValue || isoCode === searchValue;
  });

  if (matchedCountry?.isocode) {
    return matchedCountry.isocode;
  }

  return normalizedCountryValue.length === 2 ? normalizedCountryValue.toUpperCase() : normalizedCountryValue;
};

const PAYMENT_TYPE_DETAILS_BY_KEY = {
  1: { value: 'domestic-payments', label: 'Domestic payment' },
  2: { value: 'internal-payments', label: 'Internal transfer' },
  3: { value: 'sepa-payments', label: 'SEPA payment' },
  4: { value: 'international-payments', label: 'International payment' },
};

const buildAddressPayload = (beneficiaryDetails = {}, structuredAddressEnabled = false, countryList = []) => {
  const address = beneficiaryDetails.address || {};
  const beneficiaryAddress = beneficiaryDetails.beneficiaryAddress || {};
  const structuredCountryCode = resolveCountryIsoCode(beneficiaryAddress.country, countryList);
  const legacyCountryCode = resolveCountryIsoCode(address.address3, countryList);

  return {
    address: {
      address1: address.address1 || '',
      address2: address.address2 || '',
      address3: structuredAddressEnabled ? (address.address3 || '') : legacyCountryCode,
      cityName: address.cityName || address.city || '',
      country: address.country || '',
      postalCode: address.postalCode || null,
    },
    ...(structuredAddressEnabled ? {
      beneficiaryAddress: {
        city: beneficiaryAddress.city || '',
        country: structuredCountryCode,
        street: beneficiaryAddress.street || '',
        buildingNo: beneficiaryAddress.buildingNo || '',
        postCode: beneficiaryAddress.postCode || null,
      },
    } : {}),
  };
};

const getPaymentTypeDetails = (beneficiary) => {
  const paymentTypeKey = Number(beneficiary?.paymentTypeKey);
  if (PAYMENT_TYPE_DETAILS_BY_KEY[paymentTypeKey]) {
    return PAYMENT_TYPE_DETAILS_BY_KEY[paymentTypeKey];
  }

  return Object.values(PAYMENT_TYPE_DETAILS_BY_KEY).find(({ value }) => value === beneficiary?.paymentType) || {};
};

// Only show the beneficiaries for which user has to update the address details(city and country).
const hasEmptyStructuredAddress = (beneficiary) => {
  const beneficiaryAddress = beneficiary?.beneficiaryAddress || {};
  return (!beneficiaryAddress.city || beneficiaryAddress.city === '') && (!beneficiaryAddress.country || beneficiaryAddress.country === '');
};


export default () => {
  return muster()
    .path('payments.searchBankDetails', {
      call: async ({ req }, { get, set, call }) => {
        set('payments.searchBankLoading', true);
        await set('payments.IBANSegError', false);
        await set('payments.errorIBANMsg', '');
        let searchCounty = '';
        let searchSwiftCode = '';
        const { searchTermBankName, searchTermNtnlId, searchTermCity, searchTermPostalCode, ibanOrAccountNo, isIBAN, sortCode} = req.args[0];
        const [paymentType] = await getValues(get('payments.paymentType'));
        let details = '';
        let isoCode = "";
        const [countryList] = await getValues(get('payments.allCountryList'));
        if(countryList && countryList.length > 0 && searchTermPostalCode && searchTermPostalCode != "" && paymentType.includes(INTERNATIONAL_PAYMENT)){
          const country = countryList.find(item => item.countryName.toLowerCase() === searchTermPostalCode.toLowerCase());
          isoCode = country ? country.isocode : "";
        }
        // let searchCountry = ''
        if (paymentType.includes('domestic')) {
          // const searchSwiftCode = '';
          //  details = `${searchTermBankName}#@#${searchTermNtnlId}#@#${searchTermCity}#@#${searchTermPostalCode}#@#${ibanOrAccountNo}#@#${isIBAN}#@#${paymentType}#@#${searchCountry}#@#${searchSwiftCode}`;
          const bankName = isIBAN ? '' : searchTermBankName;
          const ntnlId = isIBAN ? '' : searchTermNtnlId;
          const termCity = isIBAN ? '' : searchTermCity;
          const postalCode = isIBAN ? '' : searchTermPostalCode;
          details = `${bankName}#@#${ntnlId}#@#${termCity}#@#${postalCode}#@#${ibanOrAccountNo}#@#${isIBAN}#@#${paymentType}#@#${searchCounty}#@#${searchSwiftCode}#@#${sortCode}`;

        } else if (paymentType.includes(INTERNATIONAL_PAYMENT)) {
          // const searchCountry = searchTermCity;
          // const searchSwiftCode = searchTermNtnlId;
          // details = `${searchTermBankName}#@#${searchTermNtnlId}#@#${""}#@#${searchTermPostalCode}#@#${ibanOrAccountNo}#@#${isIBAN}#@#${paymentType}#@#${searchCountry}#@#${searchSwiftCode}`;

          const bankName = isIBAN ? '' : searchTermBankName;
          const termCity = isIBAN ? '' : searchTermCity;
          searchCounty = isIBAN ? '' : isoCode;
          searchSwiftCode = isIBAN ? '' : searchTermNtnlId;
          details = `${bankName}#@#${""}#@#${termCity}#@#${""}#@#${ibanOrAccountNo}#@#${isIBAN}#@#${paymentType}#@#${searchCounty}#@#${searchSwiftCode}#@#${""}`;

        } else if (paymentType.includes('sepa')) {
          details = `${""}#@#${""}#@#${""}#@#${""}#@#${ibanOrAccountNo}#@#${isIBAN}#@#${paymentType}#@#${""}#@#${""}`;
        } else {
          details = `${searchTermBankName}#@#${searchTermNtnlId}#@#${searchTermCity}#@#${searchTermPostalCode}#@#${ibanOrAccountNo}#@#${isIBAN}#@#${paymentType}#@#${searchCounty}#@#${searchSwiftCode}`;
        }
        const guidStr = Guid();
        const [result] = await getValues(get(`${PAYMENTS_PATH}.searchBankDetails["${details}"]["${guidStr}"]`));
        isValidJsonString(result).then(async (data) => {
          const [messages] = await getValues(get('i18n.messages'));
          if (isIBAN || sortCode) {
            const isNotError = data.isIbanValid || (data && data.bankList && data.bankList[0].sortCode);
            if (isNotError) {
              let bankList = isIBAN || sortCode ? data.bankList[0] : data.bankList;
              let objectWithBenefAndBankList;
              bankList.ibanSearchedAddress = data.bankList[0].address1;
              bankList.cityName = bankList.city;
              bankList.sortCode = (data && data.bankList && data.bankList[0].sortCode);
              set('payments.errorIBANMsg', '');
              set('payments.errorSortCodeMsg', '');
              const [beneficiaryList] = await getValues(get('payments.beneficiaryList'));
              const [selectedBeneficiaryDetail] = await getValues(get('payments.selectedBeneficiaryDetail'));
              
              if(selectedBeneficiaryDetail && selectedBeneficiaryDetail.beneficiaryId && beneficiaryList) {
                let selectedBenefId = selectedBeneficiaryDetail.beneficiaryId;
                let [beneficiaryObj] = beneficiaryList.filter((beneficiary) => beneficiary.beneficiaryId == selectedBenefId);
                beneficiaryObj = { ...(beneficiaryObj || selectedBeneficiaryDetail) };
                delete beneficiaryObj.ntnlId;
                delete beneficiaryObj.bankRefId;
                bankList.beneficiaryName = `${beneficiaryObj.firstName} ${beneficiaryObj.lastName ? beneficiaryObj.lastName : ''}`
                objectWithBenefAndBankList = Object.assign({},beneficiaryObj, bankList); // Resolved WMCE-53260 new bank detail is getting overrided with old one now resolved after 
                await set('payments.selectedBeneficiaryBank', objectWithBenefAndBankList);
              } else {
                await set('payments.selectedBeneficiaryBank', bankList);
                await set('payments.selectedBeneficiaryBankSEPAPaymentType', bankList.isBankSEPAIPParticipant === IS_BANK_SEPA_PARTICIPANT.YES ? SEPA_PAYMENT_TYPE.INSTANT : SEPA_PAYMENT_TYPE.CLASSIC);
              }
              set('payments.bankList', []);
              if(data.returnCode === 301 || data.returnCode === 302){
                set('payments.errorIBANMsg', data.errorMessage);
                await set('payments.IBANSegError', true);
                set('payments.searchBankLoading', false);
              }
            } else {
               if(sortCode){
                set('payments.errorSortCodeMsg', messages['app.payment.sortCodeError']);
                set('payments.searchBankLoading', false);
               }else{
                 if(data.errorCode === "E01"){
                   set('payments.errorIBANMsg', data.errorMessage);
                   set('payments.searchBankLoading', false);
                 }else{
                   set('payments.errorIBANMsg',messages['app.payments.IBANError']);
                   set('payments.searchBankLoading', false);
                  }
                }
              //set('payments.errorIBANMsg', data.errorMessage); - EBANK-9921
              set('payments.selectedBeneficiaryBank', null);
              set('payments.bankList', []);
              set('payments.searchBankLoading', false);
            }
          } else {
            const isError = !data.bankList;
            if (isError) {
              if (data.returnCode === 130) {
                set('payments.errorIBANMsg', messages['app.payments.IBANError']);
              } else if (data.returnCode === 131) {
                set('payments.errorIBANMsg', messages['app.payments.noResult']);
              } else if (data.returnCode === 132) {
                set('payments.errorIBANMsg', messages['app.payments.IBANError.accntNum']);
              } else if (data.returnCode === 133) {
                set('payments.errorIBANMsg', messages['app.payments.searchBankError']);
              } else {
                set('payments.errorIBANMsg', messages['app.payments.IBANError']);
              }
              set('payments.selectedBeneficiaryBank', null);
              set('payments.bankList', []);
              set('payments.searchBankLoading', false);
            } else {
              set('payments.errorIBANMsg', '');
              set('payments.selectedBeneficiaryBank', null);
              set('payments.bankList', data.bankList);
              await set('payments.IBANSegError', false);
              set('payments.searchBankLoading', false);
            }
          }
        }).catch((error) => {
          set('payments.errorIBANMsg', '');
          set('payments.searchBankLoading', false)
        });
      },
    })

    .path('payments.validateBeneficiary',{
      call: async ({ req }, { get, set, call }) => {
        await set('payments.searchBankLoading', true);
        await set('payments.txTokenForAddBeneficiary', '');
        const guidStr = Guid();
        const beneficiaryDetails = req.args[0];
        const structuredAddressEnabled = await getStructuredAddressEnabled(get);
        const [countryList] = await getValues(get('payments.allCountryList'));
        const requestBeneficiaryDetails = {
          ...beneficiaryDetails,
          ...buildAddressPayload(beneficiaryDetails, structuredAddressEnabled, countryList),
        };
        let duplicateBenf = '';
        const [beneficiaryList] = await getValues(get('payments.beneficiaryList'));
        const requestObj = Base64.encode(JSON.stringify(requestBeneficiaryDetails));
        const [result] = await getValues(get(`${PAYMENT_PATH}.validateBeneficiary["${requestObj}"]["${guidStr}"]`));
        
        isValidJsonString(result).then(async (data) => {
        
          // Adding new Benef which found existing
          if(data.messageType === 'ERROR' && data.errorCode === 'BNF07') {
            
            [duplicateBenf] = beneficiaryList.filter(e => e.beneficiaryId == data.errData.beneficiaryId);
            
            await set('payments.duplicateItem', duplicateBenf);
            await set('payments.duplicateModal', true);

            // make existing beneficiaryIdToUpdate to NULL 
            await set('payments.beneficiaryIdToUpdate', null);
            await set('payments.existingBeneficiaryId', data.errData.beneficiaryId);

            set('payments.searchBankLoading', false);
            return;
          }

          // Editing Benef flow which again found existing
          if(data.messageType === 'ERROR' && data.errorCode === 'BNF21') {
            [duplicateBenf] = beneficiaryList.filter(e => e.beneficiaryId == data.errData.beneficiaryId);
            
            await set('payments.duplicateItem', duplicateBenf);
            await set('payments.duplicateModal', true);

            // make existing existingBeneficiaryId to NULL  
            await set('payments.existingBeneficiaryId', null);
            await set('payments.beneficiaryIdToUpdate', data.errData.beneficiaryId);

            set('payments.searchBankLoading', false);
            return;
          }

          if(data.status === 'SUCCESS' && !data.isCopCheckDisabled) {
            set('payments.txTokenForAddBeneficiary', data.txToken);
            if( data.accNumberResponse.status === CoP.MATCH ) {
              if(data.nameResponse.status === CoP.MATCH) {
                if(data.accTypeResponse.status === CoP.MATCH) {
                  await set('payments.accountMatchType', CoP.MATCH);
                }
                if(data.accTypeResponse.status === CoP.NO_MATCH) {
                  await set('payments.accountMatchType', CoP.ACCOUNT_TYPE_NO_MATCH);
                }
                
              }
              if(data.nameResponse.status === CoP.PARTIAL_MATCH) {
                await set('payments.CoPAccountNameMatched', data.nameResponse.newVal);
                await set('payments.accountMatchType', CoP.PARTIAL_MATCH);
                if(data.accTypeResponse.status === CoP.NO_MATCH) {
                  await set('payments.accountTypeNoMatchType', CoP.ACCOUNT_TYPE_NO_MATCH);
                }
              }
              if(data.nameResponse.status === CoP.NO_MATCH) {
                await set('payments.accountMatchType', CoP.NO_MATCH);
              }
            }

            if(data.nameResponse.status === CoP.NOT_APPLICABLE) {
              await set('payments.accountMatchType', CoP.NOT_APPLICABLE);
            }
            if( data.accNumberResponse.status === 'AC99' ) {
              await set('payments.accountMatchType', CoP.NOT_APPLICABLE);
            }
          }
          if(data.txToken) {
            await set('payments.txTokenForAddBeneficiary', data.txToken);
          }
          if(data.status === 'FAILED') {
            await set('payments.accountMatchType', CoP.NOT_APPLICABLE);
          }
          set('payments.searchBankLoading', false);
        }).catch((error) => {
          set('payments.searchBankLoading', false);
        });
        set('payments.searchBankLoading', false);
      }
    })
    .path('payments.searchCountry', {
      call: async ({ req }, { get, set, call }) => {
        const { country } = req.args[0];
        const { isAllCountry } = req.args[0];
        await set('payments.noRecordsFound', false);
        const guidStr = Guid();
        const [result] = await getValues(get(`${PAYMENTS_PATH}.searchCountry["${country}"]["${guidStr}"]`));
        isValidJsonString(result).then(async (data) => {
          if (isAllCountry) {
            await set('payments.allCountryList', data.countryList);
          } else {
            if (data.countryList.length === 0) {
              await set('payments.noRecordsFound', true);
            }
            await set('payments.countryList', data.countryList);
          }
        }).catch((error) => {
        });
      },
    })

    // Add new beneficiary
    .path('payments.addNewBeneficiary', {
      call: async ({ req }, { get, set, call }) => {
        const beneficiaryDetails = req.args[0];
        const override = req.args[1];
        const [userId] = await getValues(get('auth.userId'));
        const [paymentType] = await getValues(get('payments.paymentType'));
        const [beneficiaryIdToUpdate] = await getValues(get('payments.beneficiaryIdToUpdate'));
        const [selectedBeneficiaryDetail] = await getValues(get('payments.selectedBeneficiaryDetail'));
        const [messages] = await getValues(get('i18n.messages'));
        const [isPymtEditBenef] = await getValues(get('payments.isPymtEditBenef'));
        const [isPymtEditFrmCaptureScreen] = await getValues(get('payments.isPymtEditFrmCaptureScreen'));
        const [beneficiaryList] = await getValues(get('payments.beneficiaryList'));
        const [selectedBeneficiaryBank] = await getValues(get('payments.selectedBeneficiaryBank'));
        const [isBeneficiaryBannerFlow] = await getValues(get('payments.isBeneficiaryBannerFlow'));
        const structuredAddressEnabled = await getStructuredAddressEnabled(get);
        await set('payments.loading', true);

        const [txToken] = await getValues(get('payments.txTokenForAddBeneficiary'));
        const request = {
          txToken
        }

        const requestObj = Base64.encode(JSON.stringify(request));
        const guidStr = Guid();
        const inputParam = `${requestObj}`;
        const [oReturn] = await getValues( get(`${PAYMENT_PATH}.addNewBeneficiary["${inputParam}"]["${guidStr}"]`)
        )
        isValidJsonString(oReturn)
          .then(async (data) => { 
            let duplicateBenf='';
            if(data && data.beneficiaryId){ 
              await set('payments.beneficiaryAddressUpdateSuccess', Boolean(structuredAddressEnabled && isBeneficiaryBannerFlow));
              if(isPymtEditBenef) {
                await call('ui.history.replace', { pathname: ROUTES.PAYMENT.DESTINATION }, true);
              } else {
                await call('ui.history.replace', { pathname: ROUTES.PAYMENT.NEW_DOMESTIC }, true);
              }

              if( isPymtEditBenef || isPymtEditFrmCaptureScreen ) {
                if(beneficiaryIdToUpdate) {
                  await call('payments.deleteBeneficiary', selectedBeneficiaryDetail.beneficiaryId);
                }
              }
              
              selectedBeneficiaryBank.beneficiaryId = data.beneficiaryId;
              selectedBeneficiaryBank.isBankSepaIpParticipant = data.isBankSepaIpParticipant;
              await Promise.all([
                set('payments.isPymtAddNewBenef', true),
                set('payments.loading', false),
                set('payments.duplicateModal', false),
                set('payments.duplicateItem', null),
                set('payments.selectedBeneficiaryBank', selectedBeneficiaryBank)])
            }else if(data && data.errorCode === PAYMENT_BENF_ERROR_CODE.BENF_SAME_ACCT){
              if(selectedBeneficiaryBank.accountNo !== null){
                [duplicateBenf] = beneficiaryList.filter(e => e.accountNo === selectedBeneficiaryBank.accountNo)
              }else if(selectedBeneficiaryBank.ibanNo !== null){
                [duplicateBenf] = beneficiaryList.filter(e => e.ibanNo === selectedBeneficiaryBank.ibanNo);
              }
              await Promise.all([
                set('payments.duplicateModal', true),
                set('payments.duplicateItem', duplicateBenf),
                set('payments.loading', false)])
            }else if(data && data.errorCode){
              await Promise.all([
                  set('payments.errorMsg', data.message || messages['app.payments.failToConnect']),
                  set('payments.errorModal', true),
                  set('payments.duplicateModal', false),
                  set('payments.duplicateItem', null),
                  set('payments.loading', false)])
            } else {
              await set('payments.loading', false);
            }
            await set ('payments.beneficiaryIdToUpdate', null);
            await set ('payments.existingBeneficiaryId', null);
          })
          .catch(async (error) => {
            await Promise.all([
              set('payments.errorMsg', messages['app.payments.failToConnect']),
              set('payments.errorModal', true),
              set('payments.loading', false)])
           })
      },
    })
    // reset values of duplicate item variables
    .path('payments.resetDuplicateItem', {
      call: async ({ req }, { get, set, call }) => {
        await Promise.all([
          await set('payments.duplicateModal', false),
          await set('payments.duplicateItem', null)
        ])
    }})

     // Edit beneficiary
     .path('payments.editBeneficiary', {
      call: async ({ req }, { get, set, call }) => {
        const beneficiaryDetails = req.args[0];
        const override = req.args[1];
        const [userId] = await getValues(get('auth.userId'));
        const [messages] = await getValues(get('i18n.messages'));
        const [paymentType] = await getValues(get('payments.paymentType'));
        const [isPymtEditBenef] = await getValues(get('payments.isPymtEditBenef'));
        const [language] = await getValues(get('auth.langCode'));
        const structuredAddressEnabled = await getStructuredAddressEnabled(get);
        const [countryList] = await getValues(get('payments.allCountryList'));
        const requestBeneficiaryDetails = {
          ...beneficiaryDetails,
          ...buildAddressPayload(beneficiaryDetails, structuredAddressEnabled, countryList),
        };
        const request = {
          beneficiary : {
            userId,
            paymentType,
            ...requestBeneficiaryDetails
          },
          override,
          language
        }
        const requestObj = Base64.encode(JSON.stringify(request));
        const guidStr = Guid();
        const inputParam = `${requestObj}`;
        const [beneficiaryList] = await getValues(get('payments.beneficiaryList'));
        const [oReturn] = await getValues(
          get(`${PAYMENTS_PATH}.editBeneficiary["${inputParam}"]["${guidStr}"]`)
        )
        isValidJsonString(oReturn)
          .then(async (data) => {
            await call('payments.resetDuplicateItem');
            if(data && data.beneficiaryId){
              await call('ui.history.replace', { pathname: isPymtEditBenef ? ROUTES.PAYMENT.DESTINATION : ROUTES.PAYMENT.NEW_DOMESTIC }, true);
              await set('payments.isPymtEditBenef', false);
              await set('payments.isPymtEditFrmCaptureScreen', false);
            }else if(data && data.errorCode === PAYMENT_BENF_ERROR_CODE.BENF_SAME_ACCT){

              let duplicateBenf = beneficiaryList.filter(e => e.beneficiaryId !== beneficiaryDetails.beneficiaryId && 
                (e.accountNo === beneficiaryDetails.accountNo))[0];
  
              await Promise.all([
                set('payments.duplicateModal', true),
                set('payments.duplicateItem', duplicateBenf)])

            }else if(data && data.errorCode){
              await Promise.all([
                set('payments.errorMsg', data.message || messages['app.payments.failToConnect']),
                set('payments.errorModal', true)])
            }
          })
          .catch(async (error) => {
            await Promise.all([
              set('payments.errorMsg', messages['app.payments.failToConnect']),
              set('payments.errorModal', true)])
           })
      },
    })

    .path('payments.getBeneficiaryList', {
      call: async ({req}, {get, set, call }) => {
        await set('payments.loading', true);
        await set('payments.beneficiaryList', [])
        const [paymentType,messages] = await getValues(get(['payments.paymentType','i18n.messages']));
        const request = {
          paymentType,
        }
         
        const inputParam = Base64.encode(JSON.stringify(request));
        const guidStr = Guid();
        // const inputParam = `${requestObj}`;
        const [result ] = await getValues(get(`${PAYMENT_PATH}.getBeneficiaryList["${inputParam}"]["${guidStr}"]`));
        await isValidJsonString(result).then(async (data) =>{
          if(data && data.errorCode){
            await Promise.all([
              set('payments.errorMsg', data.message),
              set('payments.errorModal', true),
              set('payments.loading', false)])
          }else if(data.errors){
            await Promise.all([
            set('payments.errorMsg', messages['app.payments.failToConnect']),
            set('payments.errorModal', true),
            set('payments.loading', false)]);
          }else {
          await set('payments.beneficiaryList', data);
          await set('payments.loading', false); 
        }})
        .catch(async (error) => {
          await Promise.all([
            set('payments.loading', false),
            set('payments.errorMsg', messages['app.payments.failToConnect']),
            set('payments.errorModal', true)])
         });
      }
    })

    .path('payments.getBeneficiaryListAll', {
      call: async ({req}, {get, set, call }) => {
        await set('payments.loading', true);
        await set('payments.beneficiaryList', [])
        const [messages] = await getValues(get('i18n.messages'));
        const request = {};
        const inputParam = Base64.encode(JSON.stringify(request));
        const guidStr = Guid();
        const [result ] = await getValues(get(`${PAYMENT_PATH}.getBeneficiaryListAll["${inputParam}"]["${guidStr}"]`));
        await isValidJsonString(result).then(async (data) =>{
          const structuredAddressEnabled = await getStructuredAddressEnabled(get);
          if(data && data.errorCode){
            await Promise.all([
              set('payments.errorMsg', data.message),
              set('payments.errorModal', true),
              set('payments.loading', false)])
          }else if(data.errors){
            await Promise.all([
            set('payments.loading', false),
            set('payments.errorMsg', messages['app.payments.failToConnect']),
            set('payments.errorModal', true)]);
          }else {
            const beneficiaryList = Array.isArray(data) ? data : [];
            const normalizedBeneficiaries = beneficiaryList.map((beneficiary) => {
              const paymentTypeDetails = getPaymentTypeDetails(beneficiary);
              if (structuredAddressEnabled) {
                const beneficiaryAddress = beneficiary?.beneficiaryAddress || {};
                const addressLine1 = (beneficiary.address1 || '').split(' ').filter(Boolean).join(' ');

                return {
                  ...beneficiary,
                  paymentType: beneficiary.paymentType || paymentTypeDetails.value || null,
                  paymentTypeLabel: paymentTypeDetails.label || beneficiary.paymentTypeLabel || null,
                  address1: addressLine1 || null,
                  address2: beneficiary.address2 || beneficiaryAddress.postCode || null,
                  address3: beneficiary.address3 || beneficiaryAddress.country || null,
                  cityName: beneficiary.cityName || beneficiaryAddress.city || null,
                  postalCode: beneficiary.postalCode || beneficiaryAddress.postCode || null,
                  country: beneficiary.country || beneficiaryAddress.country || null,
                };
              }

              return {
                ...beneficiary,
                beneficiaryAddress: null,
                paymentType: beneficiary.paymentType || null,
                paymentTypeLabel: beneficiary.paymentTypeLabel || null,
                address1: beneficiary.address1 || null,
                address2: beneficiary.address2 || null,
                address3: beneficiary.address3 || null,
                cityName: beneficiary.cityName || null,
                postalCode: beneficiary.postalCode || null,
                country: beneficiary.country || null,
              };
            });

            const visibleBeneficiaries = structuredAddressEnabled
              ? normalizedBeneficiaries.filter(hasEmptyStructuredAddress)
              : normalizedBeneficiaries;

            await set('payments.beneficiaryList', visibleBeneficiaries);
            await set('payments.loading', false);
          }} )
        .catch(async (error) => {
          await Promise.all([
            set('payments.loading', false),
            set('payments.errorMsg', messages['app.payments.failToConnect']),
            set('payments.errorModal', true)])
         });
      }
    })
     // Delete beneficiary
     .path('payments.deleteBeneficiary', {
      call: async ({ req }, { get, set, call }) => {
        const beneficiaryId = req.args[0];
        await set('payments.loading', true);
        const [messages] = await getValues(get('i18n.messages'));
        const [selectedBeneficiaryBank] = await getValues(get('payments.selectedBeneficiaryBank'));
        const request = {
          beneficiaryId: beneficiaryId
        }
        const requestObj = Base64.encode(JSON.stringify(request));
        const guidStr = Guid();
        const inputParam = `${requestObj}`;
        const [oReturn] = await getValues(
          get(`${PAYMENTS_PATH}.deleteBeneficiary["${inputParam}"]["${guidStr}"]`)
        )
        isValidJsonString(oReturn)
          .then(async (data) => {
            if(data && data.beneficiaryId){
              const [isBeneficiaryBannerFlow] = await getValues(get('payments.isBeneficiaryBannerFlow'));
              await call(isBeneficiaryBannerFlow ? 'payments.getBeneficiaryListAll' : 'payments.getBeneficiaryList');
              await set('payments.deleteConfirmationModal', false);
              await set('payments.loading', false);
              if(selectedBeneficiaryBank && (beneficiaryId === selectedBeneficiaryBank.beneficiaryId)){
                await set('payments.selectedBeneficiaryBank', null);
                await set('payments.selectedBeneficiaryDetail', null);
              }
            }else if(data && data.errorCode){
              await Promise.all([
                set('payments.errorMsg', data.message),
                set('payments.errorModal', true),
                set('payments.loading', false)])
            }
          })
          .catch(async (error) => {
            await Promise.all([
              set('payments.errorMsg', messages['app.payments.failToConnect']),
              set('payments.errorModal', true),
              set('payments.loading', false)])
           })
      }})

      // set values of duplicate item variables
    .path('payments.setBeneficiary', {
      call: async ({ req }, { get, set, call }) => {
        const selectedBeneficiary = req.args[0];
        await Promise.all([
          set('payments.selectedBeneficiaryBank', selectedBeneficiary),
          set('payments.selectedBeneficiaryDetail', selectedBeneficiary)])
    }})

    .path('payments.isIBANSelected', variable(true))
    .path('payments.countryList', variable([]))
    .path('payments.bankList', variable([]))
    .path('payments.errorIBANMsg', variable())
    .path('payments.errorSortCodeMsg', variable())
    .path('payments.selectedBeneficiaryBank', variable(null))
    .path('payments.selectedBeneficiaryDetail', variable(null))
    .path('payments.selectedBank', variable(null))
    .path('payments.allCountryList', variable(null))
    .path('payments.searchBankLoading', variable(false))
    .path('payments.isPymtAddNewBenef', variable(false))
    .path('payments.isBeneficiaryBannerFlow', variable(false))
    .path('payments.beneficiaryAddressUpdateSuccess', variable(false))
    .path('payments.noRecordsFound',variable(false))
    .path('payments.errorMsg', variable(false))
    .path('payments.errorModal', variable(false))
    .path('payments.duplicateModal', variable(false))
    .path('payments.duplicateItem', variable(null))
    .path('payments.isPymtEditBenef', variable(false))
    .path('payments.isPymtEditFrmCaptureScreen', variable(false))
    .path('payments.deleteConfirmationModal', variable(false))
    .path('payments.loading', variable(false))
    .path('payments.IBANSegError', variable(false))
    .path('payments.accountMatchType', variable(''))
    .path('payments.accountTypeNoMatchType', variable(''))
    .path('payments.CoPAccountNameMatched', variable(''))
    .path('payments.txTokenForAddBeneficiary', variable(''))
    .path('payments.beneficiaryIdToUpdate', variable(''))
    .path('payments.existingBeneficiaryId', variable(null))
    .path('payments.isBankSepaIpParticipant', variable(false))
    .path('payments.selectedBeneficiaryBankSEPAPaymentType', variable(SEPA_PAYMENT_TYPE.CLASSIC))
};
